import React, {useEffect, useState} from 'react';
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, Modal, TextField } from '@material-ui/core';
import _ from 'lodash';
import { makeStyles } from "@material-ui/styles";
import { RiChatNewLine } from 'react-icons/ri';
import CustomSnackbar from "../../../user/shared/CustomSnackbar";
import useAdminUserSession from "../../../../hooks/useAdminUserSession";
import AdminClient from "../../client/AdminClient";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const PwtMarkAsInactiveModal = ({ teamId, handleCloseModal, handleCloseModalAndFetch, openFeedbackModal, active }) => {
  const classes = useStyles();

  const [acquired, setAcquired] = useState(false);
  const [outOfBusiness, setOutOfBusiness] = useState(false);
  const [other, setOther] = useState(false);

  const [description, setDescription] = useState('');
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const {session} = useAdminUserSession();



  useEffect(()=> {
    if (!active) {
      AdminClient.get(`/v1/admin/private_wealth_teams/${teamId}/inactive_reasons`, session).then((response) => {
        const descriptionAux = response.data['pwt_inactive_tracker']['description'];
        const reason = response.data['pwt_inactive_tracker']['reason'];
        switch (reason) {
            case 'acquired':
                setAcquired(true);
                break;
            case 'outOfBusiness':
                setOutOfBusiness(true);
                break;
            case 'other':
                setOther(true);
                break;
        }
        setDescription(descriptionAux);
      })
  }}, [])



  const filterByHandler = (event) => {
    const checked = event.target.checked;

    switch (event.target.name) {
      case 'acquired':
        setAcquired(checked);
        break;
      case 'outOfBusiness':
        setOutOfBusiness(checked);
        break;
      case 'other':
        setOther(checked);
        break;
    }
  }

  const handleOnChange = (event) => {
    event.persist();

    setDescription(event.target.value);
  }

  const handleSendData = () => {
    if (_.isEmpty(_.reject([acquired, outOfBusiness, other], (value) => (value !== true)))) {
      setSnackBarMessage('Please select an option.');
      setShowSnackBar(true);
    } else {
      let selectedOptions = [
        { option: 'acquired', value: acquired },
        { option: 'outOfBusiness', value: outOfBusiness },
        { option: 'other', value: other },
      ]


      selectedOptions = _.reject(selectedOptions, (option) => (!option.value))

      const params = {
        reason: _.map(selectedOptions, (option) => (option.option)).join(','),
        description: description,
        active: !active,
      }

      changeStatus(params);
    }
  }

  const changeStatus = (params = {}) => {
    AdminClient.put(`/v1/admin/private_wealth_teams/${teamId}/mark_as_inactive`, session, params)
        .then((response) => {
      const {
        data: {
          status,
          message,
        }
      } = response;

      if (status === 'success') {
        handleCloseModalAndFetch();
      } else {
        setSnackBarMessage(message);
        setShowSnackBar(true);
      }
    }).catch(function (thrown) {
      setSnackBarMessage(thrown.meesage);
      setShowSnackBar(true);
    });
  }

  const handleCloseSnackBar = () => {
    setShowSnackBar(false);
    setSnackBarMessage('');
  }


  const label = active ? 'Mark as Inactive' : 'Mark as Active';

  return (
    <Modal
      open={openFeedbackModal}
      onClose={handleCloseModal}
      className={classes.modal}
    >
      <div className="send-feedback-form contact">
        <div className="modal-title">
          <RiChatNewLine />
          {label}
        </div>
        <div className="modal-fields" style={{
          height: "calc(100% - 235px)"
        }}>
          <FormControl fullWidth margin="normal">
            <label className="modal-label">Reason</label>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={acquired}
                    onChange={filterByHandler}
                    key="acquired"
                    name="acquired"
                    disabled={!active}
                  />
                }
                label="Acquired"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={outOfBusiness}
                    onChange={filterByHandler}
                    key="outOfBusiness"
                    name="outOfBusiness"
                    disabled={!active}
                  />
                }
                label="Out Of Business"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={other}
                    onChange={filterByHandler}
                    key="other"
                    name="other"
                    disabled={!active}
                  />
                }
                label="Other"
              />
            </FormGroup>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <label className="modal-label">
              Details{" "}
              <span className="modal-text-optional">(optional)</span>
            </label>
            <TextField
              id="feedbackDetails"
              name="feedbackDetails"
              variant="outlined"
              multiline
              disabled={!active}
              rows={4}
              placeholder="Please provide additional information"
              value={description}
              onChange={handleOnChange}
            />
          </FormControl>
        </div>
        <div className="modal-actions">
          <Button
            className="cancel-button"
            onClick={handleCloseModal}
            variant="outlined"
            size="small"
          >
            Cancel
          </Button>
          <Button
            className="action-button"
            onClick={handleSendData}
            variant="contained"
            size="small"
          >
            {label}
          </Button>
        </div>
        <CustomSnackbar
          open={showSnackBar}
          closeHandler={handleCloseSnackBar}
          message={snackBarMessage}
          options={{
            severity: 'success'
          }}
        />
      </div>
    </Modal>
  )
}

export default PwtMarkAsInactiveModal;